import { useRouter } from 'next/router'
import { Seo } from 'ui-components'
import { App, getServerSideProps } from 'user-profile'

const Profile = (props) => {
  const {
    query: { username }
  } = useRouter()

  return (
    <>
      <Seo title={username ? `${username} - profile` : 'Loading...'} />
      <App {...props} />
    </>
  )
}

export { getServerSideProps }
export default Profile
